function envFlagToBoolean(value) {
  if (typeof value !== "string") {
    return false;
  }

  return ["1", "true", "yes", "on"].includes(value.trim().toLowerCase());
}

const NATURAL_LANGUAGE_MODEL_ID = (
  import.meta.env.VITE_TYPESENSE_NL_MODEL_ID || ""
).trim();
const NATURAL_LANGUAGE_ENABLED = envFlagToBoolean(
  import.meta.env.VITE_TYPESENSE_NL_QUERY_ENABLED
);
const NATURAL_LANGUAGE_DEBUG = envFlagToBoolean(
  import.meta.env.VITE_TYPESENSE_NL_QUERY_DEBUG
);

export function getNaturalLanguageSearchOptions({
  searchType,
  serverType = "default",
} = {}) {
  const isPrimaryCollection = serverType === "default";
  const isAllTab = !searchType || searchType === "All";
  const isEnabled =
    isPrimaryCollection &&
    isAllTab &&
    NATURAL_LANGUAGE_ENABLED &&
    Boolean(NATURAL_LANGUAGE_MODEL_ID);

  return {
    naturalLanguageSearch: {
      enabled: isEnabled,
      modelId: NATURAL_LANGUAGE_MODEL_ID,
      debug: isEnabled && NATURAL_LANGUAGE_DEBUG,
    },
  };
}
